





















































































































import Vue from 'vue';
import * as actions from '@/store/action-types';
import * as mutations from '@/store/mutation-types';
import GoToBuilderCard from '@/components/UI/GoToBuilderCard.vue';
import { IAnalyticsSnapshot, ISession } from '@/store/types';
import SessionOutcomes from '@/components/CancelAnalytics/SessionOutcomes.vue';
import MetricHistory from '@/components/CancelAnalytics/MetricHistory.vue';
import BoostedRevenue from '@/components/CancelAnalytics/BoostedRevenue.vue';
import CancellationInsights from '@/components/CancelAnalytics/CancellationInsights.vue';
import CancellationTrends from '@/components/CancelAnalytics/CancellationTrends.vue';
import FeedbackLab from '@/components/CancelAnalytics/FeedbackLab.vue';
import OfferPerformance from '@/components/CancelAnalytics/OfferPerformance.vue';
import SessionViewer from '@/components/SessionViewer.vue';
import RecentSaves from '@/components/CancelAnalytics/RecentSaves.vue';
import OverallPerformance from '@/components/CancelAnalytics/OverallPerformance.vue';
import ActivityStream from '@/components/CancelAnalytics/ActivityStream.vue';
import { mapGetters, mapState } from 'vuex';
import { LOAD_STATE } from '@/store/shared';
import eventBus from '@/helpers/event-bus';
import SentimentTrend from '@/components/SubscriptionAnalytics/SentimentTrend.vue';

export default Vue.extend({
  name: 'NextDashboard',
  components: {
    ActivityStream,
    OverallPerformance,
    RecentSaves,
    SessionOutcomes,
    GoToBuilderCard,
    SessionViewer,
    OfferPerformance,
    FeedbackLab,
    CancellationTrends,
    CancellationInsights,
    MetricHistory,
    BoostedRevenue,
    SentimentTrend,
  },
  async created() {
    this.$store.dispatch(actions.FETCH_ORG_COUPONS);
    this.$store.dispatch(actions.FETCH_RECENT_SESSIONS);
    this.$store.dispatch(actions.FETCH_TEST_SESSIONS);
    this.$store.dispatch(actions.FETCH_SESSION_FILTER_VALUES);
    this.$store.dispatch(actions.FETCH_ORG_PRICES);
  },
  data() {
    return {
      sessionSegmentSelection: '',
      viewingSession: null as ISession | null,
      isVideoActive: false,
      LOAD_STATE,
    };
  },
  computed: {
    ...mapState(['couponStats', 'couponStatsLoadState', 'pauseStats', 'pauseStatsLoadState', 'reactivationStats', 'reactivationStatsLoadState']),
    ...mapGetters(['monthsAgoChurnRate', 'monthsAgoLostSubs', 'lowData', 'orgCreatedDate', 'daysSinceOrgCreated', 'provider', 'testMode']),
    sessionsLoading(): boolean {
      return this.$store.state.recentSessionsLoadState !== LOAD_STATE.LOADED;
    },
    // indication of what CTA should be shown
    // 'NO_FLOW' | 'NO_SESSIONS' | 'LIVE';
    activationState() {
      const { state } = this.$store;
      if (!(state && state.org)) {
        return null;
      }
      const { blueprints } = state.org;
      if (!(blueprints && blueprints.length)) {
        return 'NO_FLOW';
      }
      if (!this.sessions.length) {
        if (this.testSessions.length) {
          return 'NO_LIVE_SESSIONS';
        }
        return 'NO_SESSIONS';
      }
      return 'LIVE';
    },
    sessions(): ISession[] {
      return this.$store.state.recentSessions;
    },
    testSessions(): ISession[] {
      return this.$store.state.testSessions;
    },
    dateRange(): [Date, Date] {
      return this.$store.state.dashboardDateRange;
    },
    monthlyMetricHistory(): { [key: number]: IAnalyticsSnapshot } {
      return this.$store.getters.monthlyMetricHistory;
    },
  },
  methods: {
    handleDateChange(value: Date[]): void {
      this.$store.commit(mutations.SET_DASHBOARD_DATE_RANGE, value);
    },
    viewSession(session: ISession | null) {
      this.isVideoActive = true;
      this.viewingSession = session;
    },
    openChat() {
      eventBus.$emit('openChat');
    },
  },
});
